// src/Components/aboutUsData.js
import team1 from '../assests/team1.jpg';
import team2 from '../assests/team2.jpg';
import team3 from '../assests/team3.jpg';
import team4 from '../assests/team4.jpg';
export const AboutUsCardListAR=[
    {
        id:1,
        title:" المبرمجون والمطورون",
        img: team1, // استخدام المتغير المستورد
        description:"يتكون هذا الفريق من نماذج استثنائية حصلت على شهادات وميزات عالية، تساعدهم على الإبتكار والتنافسية العالمية، وهذا ما تثبته جودة أعمالهم المطروحة في السوق، ولديهم كافة التقنيات والأجهزة التي تدعم إبداعهم، ومواظبون على الورش التطويرية المتقدمة من الخبراء والمطورين بشكل مستمر، ليتجدد إنتاجهم ومواكبتهم للتكنولوجيا.   "
    },
    {
        id:2,
        title:" خبراء التسويق",
        img: team2, // استخدام المتغير المستورد
        description:"وهؤلاء أفراد تصنفهم نتائجهم الإبداعية بأنهم فريق من النخبة، يتمتع بخبرات تسويقية فريدة، علاوة على قدرتهم في فهم العميل واستهداف الجمهور، وابتكار وسائل متجددة ومستحدثة في كل مجال. "
    },
    {
        id:3,
        title:" المصممون البصريون ",
        img: team3, // استخدام المتغير المستورد
        description:"مختصين في إنشاء قاعدة تصورية شاملة لمجال عملك، وبالرسائل التي ترغب بتوجيهها للعملاء من خلال الفن البصري المتناسق، ومتميزين في تسليط الضوء على تفانيهم وجذب الجمهور بصمت مؤثر."
    }
    ,
    {
        id:4,
        title:" المصورون",
        img: team4, // استخدام المتغير المستورد
        description:"أشخاص يتمتعون بالسرعة والمحافظة على الخصوصية والإلتزام بالمواعيد وينتجون لقطات إحترافية بجودة مرتفعة من جميع الزوايا بخفة وأريحية."
    }
   
]

export const AboutUsCardListEN=[
    {
        id:1,
        title:"Programmers & Developers",
        img: team1, // استخدام المتغير المستورد
        description:"This team comprises exceptional talents equipped with advanced certifications and skills that fuel innovation and global competitiveness—evident in their market-proven work quality. Armed with cutting-edge tools and technologies to empower their creativity, they engage in continuous professional development through advanced workshops led by industry experts. This ensures their output stays fresh and aligned with the latest technological advancements"
    },
    {
        id:2,
        title:"Marketing Experts",
        img: team2, // استخدام المتغير المستورد
        description:"These are individuals whose creative outcomes classify them as an elite team, possessing unique marketing expertise, in addition to their ability to understand the customer and target the audience, and to innovate renewed and novel methods in every field."
    },
    {
        id:3,
        title:"Visual Designers",
        img: team3, // استخدام المتغير المستورد
        description:"Specialists in creating a comprehensive conceptual foundation for your business field, and in conveying the messages you wish to communicate to customers through cohesive visual art. They excel in highlighting their dedication and attracting the audience with impactful silence."
    }
    ,
    {
        id:4,
        title:"Photographers",
        img: team4, // استخدام المتغير المستورد
        description:"Individuals who are quick, respectful of privacy, and punctual. They produce professional shots with high quality from all angles, effortlessly and comfortably."
    }
   
   
]
